import { Dialog } from "@mui/material";
import { GoogleLogin } from "@react-oauth/google";
import React from "react";
import { useTokenExchange } from "../Hooks/AuthHooks";

type LoginDialogProps = {
	open: boolean;
	onClose: () => void;
}

export function LoginDialog({ open, onClose }: LoginDialogProps) {

    const tokenExchangeMutation = useTokenExchange(onClose);

    const onSuccess = async (response: any) => {
        const idToken = response.credential as string;
		tokenExchangeMutation.mutate(idToken);

    };
    const onError = () => {
		onClose();
    }



	return (
		<Dialog open={open} onClose={onClose}>
			<GoogleLogin
				onSuccess={onSuccess}
				onError={onError}
			/>
		</Dialog>
	);
}